export class DumpsterListActivateDumpstersInput {
  dumpsters: number[];

  constructor(dumpsters: number[]) {
    this.dumpsters = dumpsters;
  }
}
